import { render, staticRenderFns } from "./Wi-fi_client.vue?vue&type=template&id=05ff4bb4&scoped=true"
import script from "./Wi-fi_client.vue?vue&type=script&lang=js"
export * from "./Wi-fi_client.vue?vue&type=script&lang=js"
import style0 from "./Wi-fi_client.vue?vue&type=style&index=0&id=05ff4bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff4bb4",
  null
  
)

export default component.exports